import { AI_SUMMARY_TYPES } from '../factFind/factFindApi';
import { AI_WORKFLOW_STATUSES } from './constants';

export const isFileExtractType = (workflowType) =>
	[
		AI_SUMMARY_TYPES.wytu,
		AI_SUMMARY_TYPES.quote,
		AI_SUMMARY_TYPES.riskInfoSummary,
		AI_SUMMARY_TYPES.quoteSummary,
		AI_SUMMARY_TYPES.riskInfoSummaryJson,
	].includes(workflowType);

export const isRiskInfoJsonType = (workflowType) =>
	workflowType === AI_SUMMARY_TYPES.riskInfoSummaryJson;

// Markdown email workflow: the email as Markdown, then compiled into the broker's Unlayer template
export const generateAIEmailSteps = ({ aiMessages, workflowType }) => [
	{
		aiMessages,
		promptType: workflowType,
		useMarkdown: true,
		status: AI_WORKFLOW_STATUSES.UNINITIALISED,
		retries: 0,
		index: 0,
	},
	{
		promptType: AI_SUMMARY_TYPES.unlayerEmailFromMarkdown,
		status: AI_WORKFLOW_STATUSES.UNINITIALISED,
		retries: 0,
		index: 1,
		isLastStep: true,
	},
];

export const generateSummarySteps = ({ filePaths, workflowType }) => {
	return [
		{
			aiMessages: [],
			filePaths: filePaths.map((path) => decodeURI(path.normalize())),
			promptType: AI_SUMMARY_TYPES.createVectorStore,
			status: AI_WORKFLOW_STATUSES.UNINITIALISED,
			retries: 0,
			index: 0,
		},
		{
			aiMessages: [],
			filePaths: filePaths.map((path) => decodeURI(path.normalize())),
			promptType: AI_SUMMARY_TYPES.fileExtract,
			status: AI_WORKFLOW_STATUSES.UNINITIALISED,
			retries: 0,
			index: 1,
		},
		{
			promptType: workflowType,
			status: AI_WORKFLOW_STATUSES.UNINITIALISED,
			retries: 0,
			index: 2,
			isLastStep: true,
		},
	];
};
